import { Link } from 'react-router-dom';
import { categories, aboutInfo } from '@/mocks/articles';

const footerLinks = {
  content: [
    { label: '时尚', path: '/category/shishang' },
    { label: '美妆', path: '/category/meizhuang' },
    { label: '生活方式', path: '/category/shenghuo' },
    { label: '摄影', path: '/category/sheying' },
    { label: '艺术', path: '/category/yishu' },
    { label: '音乐', path: '/category/yinyue' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌故事', path: '/about' },
    { label: '联系我们', path: '/about' },
  ],
  support: [
    { label: '帮助中心', path: '#' },
    { label: '内容合作', path: '#' },
    { label: '创作者入驻', path: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-semibold text-foreground-900">
                尤物视频
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              精选高颜值视频内容平台，涵盖时尚、美妆、生活方式等多元内容，为您提供最优质的视觉享受。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg text-foreground-500 hover:text-foreground-900 hover:bg-background-200 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg text-foreground-500 hover:text-foreground-900 hover:bg-background-200 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg text-foreground-500 hover:text-foreground-900 hover:bg-background-200 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Content Categories */}
          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">
              <a href="/category/shishang" className="hover:text-primary-600 transition-colors">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">
              <a href="/about" className="hover:text-primary-600 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    {...(link.path === '#' ? {} : {})}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {aboutInfo.brandName} 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}